import React, { useState, useEffect } from 'react';
import TextEditor from '../components/TextArea';
import MicIcon from "@mui/icons-material/Mic";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { useSelector, useDispatch } from "react-redux";
import {
  generate_professional_summary,
  clearPS,
  Professional_summary,
  returnHome,
  uppdateAbout,
  yof_success,
  uppdateYOF,
} from "../../../Redux/ActionCreator";
import { getOneFromServerCache } from "../../../utils/saveIntoCache";
import LoaderModal from "../../common/LoaderModal/index.jsx";
import { ToastContainer, toast } from 'react-toastify';
import { motion } from "framer-motion";


const EditSummary = ( { handleClick }) => {
  const dispatch = useDispatch();
  const prof_summary = useSelector((summary) => summary.summary);
  const info = useSelector((info) => info.personal_info);
  let YOF = useSelector(e => e.yof);
  const activity = useSelector((act) => act.activities);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const Tech_skills = useSelector((e) => e.skills);
  const p_profile = useSelector((e) => e.profile);

  const [summary, setSummary] = useState("");
  let [ yof, setYof ] = useState("");

  const [isListening, setIsListening] = useState(false);
  // Speech Recognition Hook
  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } =
  useSpeechRecognition();

  useEffect(() => {
    if (transcript !== "" && transcript !== null && transcript !== undefined) {
      setSummary(transcript);
    } // Update text editor with recognized speech
  }, [transcript]);

  // Handle Microphone Start/Stop
  const handleMicClick = () => {
    if (!browserSupportsSpeechRecognition) {
      alert("Your browser does not support speech recognition.");
      return;
    }

    if (listening) {
      SpeechRecognition.stopListening();
    } else {
      resetTranscript(); // Reset transcript before starting new speech
      SpeechRecognition.startListening({ continuous: true });
    }
    setIsListening(!isListening);
  };

  useEffect(() => {
    if (!window.location.pathname.includes("/user/profile")) {
      if (prof_summary.summary !== null) {
        setSummary(prof_summary.summary);
        setYof(YOF.message);
      } else {
        // get from the server cache
        let cacheInfo = getOneFromServerCache("summary")
        cacheInfo.then(res => res.json())
          .then(res => {
            if (res.success === true) {
              if (res.data !== null && res.data !== undefined) {
                let resObj = JSON.parse(res.data);
                // console.log("respObj", resObj);
                dispatch(Professional_summary(resObj));
                setSummary(resObj);
              }
              // console.log("Done");
            } else if (res.success === false && res.message == "Unauthorized") {
              dispatch(returnHome(res.status));
            }
          }).catch(err => {
            // console.log("Error getting personal info", err)
          })
      }
    } else if (window.location.pathname.includes("/user/profile")) {
      if (p_profile.message !== null) {
        setSummary(p_profile.message?.About);
        setYof(p_profile.message?.Years_of_experience)
      }
    }

  }, []);

  useEffect(() => {
    if (prof_summary.summary !== null) {
      // prefill the summary into the summary textarea
      setSummary(prof_summary.summary);
      setLoading(false);
    }
  }, [prof_summary])

  const [ loading, setLoading ] = useState(false)
  const handleGenerateSummary = () => {
    dispatch(clearPS());
    const cred = {
      Experience: activity?.activities,
      Technical_skills: Tech_skills?.skills,
      Language: flowLanguage || "English", // Language,
      CvType: info.message?.JobInterests[0]?.value !== undefined ? info.message?.JobInterests[0]?.value : info.message?.JobInterests[0],
      summary: summary,
      type: "create professional summary"
    };
    // console.log("executing professional summary generating process");
    dispatch(generate_professional_summary(cred));
    setLoading(true);
  }

  const handleNextCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    try {
        if (summary !== null) {
          if (p_profile.message !== null && ((p_profile.message?.About == null || p_profile.message?.About == undefined) || window.location.pathname.includes("/user/profile"))) {
            dispatch(uppdateAbout(summary));
          }
          // dispatch(yof_success(yof));
          dispatch(uppdateYOF(yof));
          handleClick();
        } else {
          setTimeout(() => {
              toast.error("Professional summary is required", {
                  position: toast.POSITION.TOP_RIGHT,
              });
          }, 50);
        }
    } catch (error) {
        throw error
    }
  }

  const[ showYofPlaceholder, setShowYofPlaceholder ] = useState(true);

  return (
    <>
    <div className="p-6 bg-white rounded-lg shadow-md w-full md:w-2/3 lg:w-1/2 mx-auto">
      <h2 className="text-2xl font-bold text-[#5843BD] mb-4 text-center">Edit your professional summary.</h2>
      <div className="flex w-full vsm:my-6 md:my-4 vsm:justify-center lg:justify-start">
        <div className="w-full flex vsm:justify-center md:justify-start">
            <div className="w-full">
                <label htmlFor="firstName" className="text-black font-medium text-sm mb-2">
                  How many years of experience do you have in this field?
                </label>
                <input
                type="text"
                id="expeirence"
                className="w-full border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                value={yof}
                onChange={(e) => setYof(e.target.value)}
                placeholder={showYofPlaceholder == false ? "" : "2"}
                onFocus={() => setShowYofPlaceholder(false)}
                onBlur={() => setShowYofPlaceholder(true)}
                />
            </div>
        </div>
      </div>
      <div>
        <p className="text-gray-600 mt-4">
            Use the rich text editor to cleanly format text in your summary. Click on the microphone to speak instead.
        </p>
        <div className="mt-2 w-full relative">          
            <TextEditor
              className="h-56 w-full xl:w-full 2xl:w-full rounded-lg border border-radius border-indigo-400 border-opacity-30 focus:outline-none focus:border-2 focus:border-indigo-400 placeholder:text-[#B3B3B3] text-4xl font-normal notranslate"
              style={{ resize: "none" }}
              placeholder="Start typing or use the microphone..."
              value={summary}
              onChange={(value) => setSummary(value)}
              required
              notranslate
            />

            {/* Microphone Button */}
            <motion.button
              onClick={handleMicClick}
              className={`absolute top-[8%] right-7 p-1 rounded-full shadow-lg transition duration-300 
                ${listening ? "bg-red-500 hover:bg-red-600" : "bg-purple-500 hover:bg-purple-600"}`}
              animate={{
                scale: [1, 1.3, 1],
                y: [0, -15, 0],
                // rotate: [0, 40, -40, 0],
                filter: [
                  "drop-shadow(0px 0px 0px rgba(255,255,255,0))",
                  "drop-shadow(0px 0px 15px rgba(255,255,255,1))",
                  "drop-shadow(0px 0px 0px rgba(255,255,255,0))"
                ],
              }}
              transition={{
                duration: 0.5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <MicIcon className="text-white text-xxl" />
            </motion.button>
        </div>
      </div>
      <div className="flex justify-center my-4">
        <button
          className="bg-gradient-to-r max-w-max from-[#FF6633] to-[#5843BD] text-white font-medium py-3 px-[20px] rounded-[50px] shadow-md hover:from-[#5843BD] hover:to-[#FF6633] transition-colors duration-300 flex items-center justify-center text-xl"
          onClick={handleGenerateSummary}
        >
          CREATE SUMMARY
          <span className="ml-2">
            <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1740040104/Website%20images/moil-white-logo_fndycf.png" alt="Moil white logo" />
          </span>
        </button>

      </div>
      <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center my-2">
          <div className="flex justify-between lg:max-w-[90vw] w-full">
              <button
                  onClick={handleClick}
                  className="border-[#FF6633] border flex items-center gap-x-2 text-black font-medium py-4 px-4 rounded-md"
              >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                      "Cancelar"
                    ) : (
                      "CANCEL"
                    )}
                  </span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="24" height="24" rx="12" fill="#FF6633"/>
                      <path d="M15.1893 18C15.1132 18 15.0412 17.9653 14.9938 17.9058L12.0561 14.2175C11.953 14.0881 11.7548 14.0927 11.6579 14.2269L9.00599 17.8964C8.95899 17.9615 8.88362 18 8.80337 18H6.07388C5.86606 18 5.74897 17.7612 5.87625 17.5969L10.132 12.1039C10.2027 12.0127 10.2017 11.8849 10.1297 11.7948L5.82441 6.40605C5.69361 6.24233 5.81018 6 6.01973 6H8.81098C8.88693 6 8.95877 6.03453 9.00621 6.09384L11.9435 9.76586C12.0469 9.89503 12.2449 9.89004 12.3416 9.75583L14.9727 6.10386C15.0197 6.03865 15.0952 6 15.1756 6H17.9053C18.1131 6 18.2302 6.23864 18.1031 6.40295L13.8676 11.8792C13.7971 11.9703 13.798 12.0978 13.8698 12.1879L18.1767 17.5942C18.3072 17.758 18.1906 18 17.9812 18H15.1893Z" fill="white"/>
                  </svg>

              </button>
              <button
                  onClick={handleNextCall}
                  className="bg-[#5843BD] flex items-center gap-x-2 text-white font-medium py-3 px-4 rounded-md"
              >
                <span className="notranslate" key={flowLanguage}>
                  {flowLanguage == "Spanish" ? (
                    "GUARDAR"
                  ) : (
                    "SAVE"
                  )}
                </span>
                  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
              </button>

          </div>
      </div>
      <ToastContainer />
    </div>
    { loading && <LoaderModal text="Our AI is generating your Professional summary for you..."/>}
    </>
  );
};

export default EditSummary;
